<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="title"
    :close-on-click-modal="false"
    width="1000px"
    append-to-body
    class="app-main-inner bill-edit-charge-dialog"
  >
    <div class="app-main-inner-row">
      <el-form label-position="left" label-width="90px">
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$t('SeaExport.BusinessNo')">
              <el-select v-model="form.jobUuid" :disabled="!!form.uuid" style="width: 100%" @change="onJobChange">
                <el-option v-for="(item, index) in simpleJobs" :key="index" :label="item.jobNo" :value="item.uuid" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('SeaExport.ChargeItem')">
              <cargo-advance-select
                filterable
                :method-params="chargeItemFilter"
                :select-type="selectTypeNames.basic_data_ChargeItem"
                :default-value="Number(form.chargeItemId) || ''"
                options-width="250px"
                tag-value="itemId"
                tag-name="zhName"
                @parentCallBack="p=>onCellChange('chargeItemId', p.value)"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('SeaExport.Currency')">
              <cargo-advance-select
                filterable
                :clearable="false"
                :select-type="selectTypeNames.basic_data_Currency"
                :method-params="splitBill ? { code: charge.currency } : {}"
                :default-value="form.currency || ''"
                options-width="100px"
                @parentCallBack="p=>onCellChange('currency', p.value)"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$t('SeaExport.UnitRate')">
              <el-input-number
                v-model="form.unitRate"
                :max="999999999"
                :min="-999999999"
                style="width: 100%"
                :precision="2"
                :controls="false"
                @change="onCellChange('unitRate')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('SeaExport.ExcludingTaxAmount')">
              <el-input-number
                v-model="form.excludingTaxAmount"
                :max="999999999"
                :min="-999999999"
                style="width: 100%"
                :precision="2"
                :controls="false"
                @change="onCellChange('excludingTaxAmount')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('SeaExport.TaxRate') + '%'">
              <el-input-number
                v-model="form.taxRate"
                :max="999999999"
                :min="-999999999"
                style="width: 100%"
                :precision="2"
                :controls="false"
                @change="onCellChange('taxRate')"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$t('SeaExport.Quantity2')">
              <el-input-number
                v-model="form.quantity"
                :max="999999999"
                :min="-999999999"
                style="width: 100%"
                :precision="2"
                :controls="false"
                @change="onCellChange('quantity')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('SeaExport.IncludingTaxAmount')">
              <el-input-number
                v-model="form.amount"
                :max="999999999"
                :min="-999999999"
                style="width: 100%"
                :precision="2"
                :controls="false"
                @change="onCellChange('amount')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('SeaExport.BillAmount')">
              <el-input-number
                v-model="form.taxAmount"
                :max="999999999"
                :min="-999999999"
                style="width: 100%"
                :precision="2"
                :controls="false"
                :disabled="true"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$t('SeaExport.Unit')">
              <cargo-advance-select
                :select-type="selectTypeNames.local_cache_ChargeMeasure"
                filterable
                :clearable="false"
                options-width="100px"
                :method-params="{ seaFreight: true }"
                :default-value="form.measure || ''"
                @parentCallBack="p=>onCellChange('measure', p.value)"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('FinanceManage.charge_unitPriceIncludeTax')">
              <cargo-advance-select
                filterable
                :clearable="false"
                :fields="['value']"
                :default-value="form.unitPriceIncludeTax"
                :cache="false"
                tag-value="code"
                tag-name="value"
                options-width="130px"
                :static-options="[{code:true,value:$t('SeaExport.Yes')},{code:false,value:$t('SeaExport.No')}]"
                :filter-tag-names="['value']"
                @parentCallBack="p=>onCellChange('unitPriceIncludeTax', p.value)"
              />
            </el-form-item>
          </el-col>
          <el-col v-if="form.oversea" :span="8">
            <el-form-item :label="$t('CargoMsg.Cargo_PaymentType')">
              <el-select v-model="form.receivable" :disabled="!!form.uuid" style="width: 100%">
                <el-option label="DEBIT" :value="true" />
                <el-option label="CREDIT" :value="false" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="16">
            <el-form-item :label="$t('SeaExport.Remarks')">
              <el-input v-model="form.remarks" type="textarea" :rows="5" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-button type="primary" size="mini" @click="save">{{ $t("CargoMsg.Cargo_Save") }}</el-button>
      <el-button size="mini" @click="innerVisible=false">{{ $t("SeaExport.Cancel") }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cache } from '@/utils/cacheManager'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { ChargeColumnUtil } from '@/class/cargo/model/utils/ChargeColumnUtil'
import { Charge } from '@/class/model/act/Charge'
import { assemblyChargeOfBilling } from '@/api/clearing/charge'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'

export default {
  name: 'BillEditChargeDialog',
  components: { CargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    title: { type: String, required: true },
    simpleJobs: { type: Array, required: true },
    job: { type: Object, required: true },
    charge: { type: Object, required: true },
    currencyList: { type: Array, required: true },
    billing: { type: Object, required: true },
    splitBill: { type: Boolean, default: false }
  },
  data() {
    return {
      innerVisible: false,
      selectTypeNames: TYPE_NAMES,
      jobs: [],
      form: new Charge().fillDefaultValue().getData(),
      selectJob: {},
      privilege: {
        isControlled: this.$checkPermission(['button_Charge_controlled']), // 是否有应付受控费用权限
        isCostControlled: this.$checkPermission(['button_Charge_costControlled']) // 是否有应收受控费用权限
      },
      isSpecialExpenseEntryFunction: false,
      currentViewCacheData: { // 表格下拉等数据map缓存，为了解决 表格渲染卡顿问题
        chargeMeasureSet: [], // 费用单位
        currencySet: [], // 币种
        companyContactPersonMap: new Map(), // company对应的联系人map 缓存
        customerSettlementAgentMap: new Map(), // 结算对象关联的结算代理
        chargeItemSet: new Set()
      }
    }
  },
  computed: {
    chargeItemFilter() {
      const filter = {}
      if (this.charge.receivable) {
        if (!this.privilege.isCostControlled) {
          filter.controlled = false
        }
      } else {
        if (!this.privilege.isControlled) {
          filter.controlled = false
        }
      }
      if (this.isSpecialExpenseEntryFunction) {
        filter.specialExpenseMarker = false
      }
      filter.active = true
      return filter
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          this.form = { ...this.charge }
          this.isSpecialExpenseEntryFunction = Number(cache.config.get('SpecialExpenseEntryFunction')) === 1
          this.initJobData()
        }
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    async initJobData() {
      this.jobs = [this.job]
      const pendingJobs = this.simpleJobs.filter(p => p.uuid !== this.job.uuid)
      if (pendingJobs.length > 0) {
        const loading = getLoading4Cxt(this)
        try {
          for (const pendingJob of pendingJobs) {
            const job = { ... pendingJob }
            switch (this.job.lob) {
              case 'SE':
                await new SeaExportJob(job).loadJobRelated({ job: true, seaCargoDoc: true })
                break
            }
            this.jobs.push(job)
          }
        } finally {
          loading.close()
        }
      }
      this.selectJob = this.jobs.find(p => p.uuid === this.form.jobUuid)
    },
    onJobChange() {
      this.selectJob = this.jobs.find(p => p.uuid === this.form.jobUuid)
      this.form.businessDate = this.selectJob.businessDate
    },
    // 列修改事件
    async onCellChange(field, newValue) {
      let oldValue = ''
      if (newValue === undefined) {
        oldValue = this.charge[field]
        newValue = this.form[field]
      } else {
        oldValue = this.form[field]
        this.form[field] = newValue
      }
      let firstAccountId = false
      if (!oldValue) {
        firstAccountId = true
      }
      const newParams = {
        rowIndex: 0,
        colId: field,
        data: this.form,
        field,
        value: newValue,
        firstAccountId,
        originalValue: oldValue
      }
      await this.chargeGridItemEditEndHandler(newParams)
    },
    // 应收,应付用同一个事件
    async chargeGridItemEditEndHandler(params) {
      const charge = params.data
      switch (params.field) {
        case 'chargeItemId': {
          await ChargeColumnUtil.chargeItemChange(charge, params, true, this.selectJob, this.currentViewCacheData, 1)
          charge.accountId = this.billing.accountId
          charge.settlementAgentId = this.billing.settlementAgentId
          charge.invoiceTitle = this.billing.title
          break
        }
        case 'currency': {
          await ChargeColumnUtil.currencyChangeHandler(charge, this.selectJob)
          break
        }
        case 'unitRate': {
          ChargeColumnUtil.unitRateChange(charge, params)
          break
        }
        case 'excludingTaxAmount': {
          ChargeColumnUtil.excludingTaxAmountChange(charge, params)
          break
        }
        case 'taxRate': {
          ChargeColumnUtil.taxRateChange(charge, params)
          break
        }
        case 'quantity': {
          ChargeColumnUtil.quantityChange(charge, params)
          break
        }
        case 'amount': {
          ChargeColumnUtil.amountChange(charge, params)
          break
        }
        case 'measure': {
          await ChargeColumnUtil.changeChargeMeasureCombo(charge, params, this.selectJob)
          break
        }
        case 'unitPriceIncludeTax': {
          await ChargeColumnUtil.unitPriceIncludeTaxChange(charge)
          break
        }
      }
      if (this.splitBill) {
        this.form.currency = this.charge.currency
      }
    },
    async save() {
      if (!this.form.chargeItemId) {
        this.$message.warning(this.$t('queryJob.TheNameCannotBeEmpty'))
        return
      }
      if (!this.form.currency) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CurrencyCanTBeEmpty'))
        return
      }
      const currencyCount = this.currencyList.includes(this.form.currency) ? this.currencyList.length : this.currencyList.length + 1
      if (currencyCount > 3) {
        this.$message.warning(this.$t('queryJob.BillUpTo3Currencies'))
        return
      }
      if (!this.form.unitRate) {
        this.$message.warning(this.$t('Message.UnitRateCannotBeNull'))
        return
      }
      if (!this.form.measure) {
        this.$message.warning(this.$t('Message.MeasureCannotBeNull'))
        return
      }
      const loading = getLoading4Cxt(this)
      try {
        const billCharge = await assemblyChargeOfBilling(this.form).then(res => res.data)
        billCharge._charge = this.form
        this.$emit('callback', billCharge)
        this.innerVisible = false
      } finally {
        loading.close()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.bill-edit-charge-dialog::v-deep {
  .el-input-number .el-input input {
    text-align: left;
  }
}
</style>
